const seoData = {
  home: {
    title: "WiaSoft | Geleceğin Yazılım Çözümleri ve Dijital Dönüşüm Hizmetleri",
    description: "WiaSoft, profesyonel web yazılım, mobil uygulama geliştirme ve dijital dönüşüm çözümleri ile işinizi geleceğe taşır. 8 yıllık deneyimle yanınızdayız.",
    keywords: "yazılım şirketi, web yazılım, mobil uygulama, robotik kodlama, dijital dönüşüm, wiasoft"
  },
  about: {
    title: "Hakkımızda | WiaSoft Yazılım ve Teknoloji Çözümleri Ekibimiz",
    description: "WiaSoft'un hikayesi, vizyonu ve misyonu hakkında bilgi edinin. 8 yıllık tecrübemizle şeffaflık ve müşteri memnuniyeti odaklı çalışıyoruz.",
    keywords: "wiasoft hakkında, yazılım ekibi, vizyon misyon, teknoloji şirketi"
  },
  services: {
    title: "Yazılım Hizmetlerimiz | Web, Mobil ve Masaüstü Yazılım Çözümleri",
    description: "Web yazılımlarından mobil uygulamalara, masaüstü çözümlerinden robotik kodlamaya kadar geniş bir yelpazede sunduğumuz teknoloji hizmetlerini keşfedin.",
    keywords: "yazılım hizmetleri, web geliştirme, mobil uygulama geliştirme, robotik çözümler"
  },
  contact: {
    title: "İletişim | WiaSoft Yazılım Şirketi Telefon ve Adres Bilgileri",
    description: "WiaSoft ile iletişime geçin. Sorularınız, projeleriniz veya iş birlikleri için yanınızdayız. +90 850 308 0942 numaralı hattan bize ulaşabilirsiniz.",
    keywords: "wiasoft iletişim, yazılım firması telefon, adres, destek hattı"
  },
  webSoftware: {
    title: "Web Yazılım ve Kurumsal Web Sitesi Geliştirme Hizmetleri",
    description: "Modern, hızlı ve SEO uyumlu web yazılımları ile markanızı dijital dünyada öne çıkarın. Kurumsal web sitelerinden özel web uygulamalarına kadar her şey.",
    keywords: "web yazılım, kurumsal web sitesi, e-ticaret yazılımı, react geliştirme"
  },
  mobileSoftware: {
    title: "Mobil Uygulama Geliştirme | iOS ve Android Uygulama Çözümleri",
    description: "iOS ve Android platformları için yüksek performanslı, kullanıcı dostu mobil uygulamalar geliştiriyoruz. Fikrinizi cebinize taşıyoruz.",
    keywords: "mobil uygulama, ios uygulama, android uygulama, react native, uygulama geliştirme"
  },
  desktopSoftware: {
    title: "Masaüstü Yazılım Geliştirme ve Otomasyon Sistemi Çözümleri",
    description: "İş süreçlerinizi hızlandıran, güvenilir ve özelleştirilmiş masaüstü yazılım çözümleri. Windows, macOS ve Linux uyumlu uygulamalar.",
    keywords: "masaüstü yazılım, windows uygulama, özel yazılım, otomasyon sistemleri"
  },
  globalApplications: {
    title: "Global Pazar Uygulamaları ve Uluslararası Yazılım Geliştirme",
    description: "Dünya standartlarında, çok dilli ve küresel pazara hitap eden uygulama çözümleri ile sınırları aşın.",
    keywords: "global yazılım, uluslararası pazar, çok dilli uygulama, küresel çözümler"
  },
  roboticCoding: {
    title: "Robotik Kodlama Yazılımları ve Endüstriyel Otomasyon Sistemleri",
    description: "Endüstriyel otomasyon ve eğitim odaklı robotik kodlama çözümleri ile geleceğin teknolojisini bugünden inşa edin.",
    keywords: "robotik kodlama, otomasyon yazılımı, endüstri 4.0, robot yazılımları"
  },
  softwareProcesses: {
    title: "Yazılım Geliştirme Süreçleri ve Proje Yönetim Metodolojimiz",
    description: "Planlamadan canlıya almaya kadar WiaSoft yazılım geliştirme metodolojisini ve profesyonel süreçlerimizi inceleyin.",
    keywords: "yazılım süreçleri, agile geliştirme, yazılım yaşam döngüsü, proje yönetimi"
  },
  securityData: {
    title: "Güvenlik ve Veri Koruma | Siber Güvenlik ve KVKK Çözümleri",
    description: "Dijital varlıklarınızı korumak için en son güvenlik protokolleri ve veri koruma standartları ile çalışıyoruz. Veriniz bizimle güvende.",
    keywords: "veri güvenliği, siber güvenlik, kvkk uyumu, yazılım güvenliği"
  },
  softwareTrends: {
    title: "Yazılım Trendleri | Geleceğin Teknolojileri ve Yapay Zeka",
    description: "Teknoloji dünyasındaki en son gelişmeleri ve yazılım trendlerini WiaSoft ile takip edin. Geleceğe hazırlıklı olun.",
    keywords: "yazılım trendleri, yapay zeka, blockchain, teknoloji haberleri"
  },
  downloadCenter: {
    title: "İndirme Merkezi | WiaSoft Ürün Sürücüleri ve Dokümanları",
    description: "WiaSoft tarafından geliştirilen ürünler, sürücüler ve dokümanlar için indirme merkezini ziyaret edin.",
    keywords: "yazılım indir, sürücü indir, wiasoft dökümanlar"
  },
  documents: {
    title: "Dokümanlar | Teknik Kullanım Kılavuzları ve Yasal Belgeler",
    description: "Ürünlerimize ait kullanım kılavuzları, teknik dökümanlar ve yasal bildirimlere buradan ulaşabilirsiniz.",
    keywords: "teknik döküman, kullanım kılavuzu, yasal belgeler"
  },
  privacyPolicy: {
    title: "Mobil Uygulama Gizlilik Bildirimi ve Kişisel Veri Politikası",
    description: "Mobil uygulamalarımızdaki veri toplama ve gizlilik politikalarımız hakkında detaylı bilgi edinin.",
    keywords: "gizlilik politikası, veri gizliliği, mobil uygulama güvenliği"
  },
  faq: {
    title: "Sıkça Sorulan Sorular | Yazılım Süreçleri ve Destek Hakkında",
    description: "WiaSoft hizmetleri, süreçleri ve merak ettiğiniz tüm soruların cevapları SSS sayfamızda.",
    keywords: "sss, yazılım soruları, destek, yardım"
  },
  notFound: {
    title: "404 Sayfa Bulunamadı | WiaSoft Yazılım ve Teknoloji",
    description: "Aradığınız sayfa mevcut değil veya taşınmış olabilir. Lütfen anasayfaya dönün.",
    noindex: true
  }
};

export default seoData;
